import { render, staticRenderFns } from "./GeneratedAvatar.vue?vue&type=template&id=2edd3fe4"
import script from "./GeneratedAvatar.vue?vue&type=script&lang=ts"
export * from "./GeneratedAvatar.vue?vue&type=script&lang=ts"
import style0 from "./GeneratedAvatar.vue?vue&type=style&index=0&id=2edd3fe4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_css-loader@3.6.0_webpack@4.47.0__ejs@3.1.10_be517b630ad34e2df4a68e8854480672/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports